/**
 *
 * CheckboxInput
 *
 */

import React from 'react';
import PropTypes from 'prop-types';

import Label from 'components/Label';

import Tick from 'assets/allIcons/ui/icon_ui_tick.svg';

import CheckboxInputWrapper from './styles/CheckboxInputWrapper';
import CheckboxInputIcon from './styles/CheckboxInputIcon';
import CheckboxInputInput from './styles/CheckboxInputInput';
import CheckboxInputInputField from './styles/CheckboxInputInputField';


class CheckboxInput extends React.PureComponent {
  // eslint-disable-line react/prefer-stateless-function
  constructor() {
    super();

    this.handleOnChange = this.handleOnChange.bind(this);
  }

  handleOnChange() {

    const {
      valueList,
      valueListIndex,
      onChange
    } = this.props;

    onChange(valueList, valueListIndex);
  }


  render() {
    const {
      readOnly,
      checked,
      disabled,
      id,
      name,
      value,
      label,
      thisStyles,
      thisLabelStyles
    } = this.props;

    return (
      <CheckboxInputWrapper thisStyles={thisStyles}>
        <CheckboxInputInput
          checked={checked}
          disabled={disabled}
          id={id}
          name={name}
          onChange={this.handleOnChange}
          readOnly={readOnly}
          type={'checkbox'}
          value={value}
        />
        <CheckboxInputInputField htmlFor={id} />
        <CheckboxInputIcon icon={Tick} />
        {
          label ? (
            <Label title={label} thisStyles={thisLabelStyles}/>
          ) : ''
        }

      </CheckboxInputWrapper>
    );
  }
}

CheckboxInput.propTypes = {
  checked: PropTypes.bool,
  disabled: PropTypes.bool,
  id: PropTypes.string,
  name: PropTypes.string,
  onChange: PropTypes.func,
  readOnly: PropTypes.bool,
  label: PropTypes.string,
  thisStyles: PropTypes.object,
  thisLabelStyles: PropTypes.object,
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};

export default CheckboxInput;
